// Sunrise/sunset (NOAA-style approximation, accurate to a few minutes).
const rad = Math.PI / 180;

function sunTimes(date, lat, lng) {
  const day = Math.floor((Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()) - Date.UTC(2000, 0, 1)) / 864e5);
  const n = day - lng / 360;
  const M = (357.5291 + 0.98560028 * n) % 360;
  const C = 1.9148 * Math.sin(M * rad) + 0.02 * Math.sin(2 * M * rad) + 0.0003 * Math.sin(3 * M * rad);
  const L = (M + C + 180 + 102.9372) % 360;
  const transit = 2451545 + n + 0.0053 * Math.sin(M * rad) - 0.0069 * Math.sin(2 * L * rad);
  const dec = Math.asin(Math.sin(L * rad) * Math.sin(23.44 * rad));
  const cosH = (Math.sin(-0.833 * rad) - Math.sin(lat * rad) * Math.sin(dec)) / (Math.cos(lat * rad) * Math.cos(dec));
  if (cosH > 1) return { polar: "night" };
  if (cosH < -1) return { polar: "day" };
  const H = Math.acos(cosH) / rad / 360;
  const toDate = (j) => new Date((j - 2440587.5) * 864e5);
  return { rise: toDate(transit - H), set: toDate(transit + H) };
}

const lastPos = () => { try { return JSON.parse(localStorage.getItem("fhp-last-pos")); } catch { return null; } };

export function isNight(now = new Date()) {
  const p = lastPos();
  if (p && Number.isFinite(p.lat)) {
    const st = sunTimes(now, p.lat, p.lng);
    if (st.polar) return st.polar === "night";
    return now < st.rise || now > st.set;
  }
  const h = now.getHours() + now.getMinutes() / 60;
  return h >= 19.5 || h < 6.5;
}
